import styled from "styled-components";

export const StyledOnboardingHubButtonWrapper = styled.div`
    width: 100%;
`;
